import { render } from "./CartDetails.vue?vue&type=template&id=bf2bf534"
import script from "./CartDetails.vue?vue&type=script&lang=js"
export * from "./CartDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__